export class Permisos {
  static Compania = {
    LISTAR: "ECF.Admin.Compania.LISTAR",
    EDITAR: "ECF.Admin.Compania.EDITAR",
    CREAR: "ECF.Admin.Compania.CREAR",
    BLOQUEAR: "ECF.Admin.Compania.Bloquear",
    LISTAR_HIJAS: "ECF.Admin.Compania.ListarHijas",
    CREAR_VINCULADA: "ECF.Admin.Compania.CrearCiaVinculada"
  };

  static Perfil = {
    LISTAR: "ECF.Perfil.LISTAR",
    EDITAR: "ECF.Perfil.EDITAR",
    CREAR: "ECF.Perfil.CREAR",
  };

  static Usuario = {
    LISTAR: "ECF.Usuario.LISTAR",
    EDITAR: "ECF.Usuario.EDITAR",
    CREAR: "ECF.Usuario.CREAR",
    ACTUALIZAR_PASSWORD: "ECF.Seguridad.ActualizarUsuarioPassword",
  };

  static Seguridad = {
    SACAR_USUARIO_SESION: "ECF.Seguridad.Login.SacarUsuarioSesion",
    CREAR_TOKEN: "ECF.Seguridad.CrearToken",
    INACTIVAR_TOKEN: "ECF.Seguridad.InactivarToken",
    CONFIGURACION_LISTAR: "ECF.Seguridad.Configuracion.Ver",
  };

  static Documentacion = {
    DOCUMENTACION_LISTAR: "ECF.Documentacion.Ver",
  };

  static ComprobanteElectronico = {
    LISTAR: "ECF.ComprobanteElectronico.LISTAR",
    FIRMAR: "ECF.ComprobanteElectronico.FIRMAR",
    CARGAR: "ECF.ComprobanteElectronico.CARGAR",
  };

  static AnulacionSecuencia = {
    LISTAR: "ECF.AnulacionSecuencia.LISTAR",
    CREAR: "ECF.AnulacionSecuencia.CREAR",
  };

  static ConsultarDirectorios = {
    LISTAR: "ECF.ConsultarDirectorios.LISTAR",
  };

  static AprobacionComercial = {
    LISTAR: "ECF.AprobacionComercial.LISTAR",
    CREAR: "ECF.AprobacionComercial.CREAR",
  };

  static ComprobantesRecibidos = {
    LISTAR: "ECF.ComprobantesRecibidos.LISTAR",
  };

  static Archivo = {
    LISTAR: "ECF.Archivo.LISTAR",
  };

  static Reportes = {
    IMPRIMIR: "ECF.Reporte.Imprimir",
  };

  static Compras = {
    IMPRIMIR: "ECF.Transaccion.Compras.Imprimir",
  };

  static Exportaciones = {
    IMPRIMIR: "ECF.Transaccion.Exportaciones.Imprimir",
  };

  static FacturasConsumo = {
    IMPRIMIR: "ECF.Transaccion.FacturasConsumo.Imprimir",
  };

  static Facturas = {
    IMPRIMIR: "ECF.Transaccion.Facturas.Imprimir",
  };

  static GastoMenor = {
    IMPRIMIR: "ECF.Transaccion.GastoMenor.Imprimir",
  };

  static NotaCredito = {
    IMPRIMIR: "ECF.Transaccion.NotaCredito.Imprimir",
  };

  static NotaDebito = {
    IMPRIMIR: "ECF.Transaccion.NotaDebito.Imprimir",
  };

  static PagosExterior = {
    IMPRIMIR: "ECF.Transaccion.PagosExterior.Imprimir",
  };

  static Transacciones = {
    IMPRIMIR: "ECF.Transaccion.Transacciones.Imprimir",
    CANCELAR: "ECF.Transacciones.Transacciones.CANCELAR",
    VISUALIZAR_LINK_QR: "ECF.Transaccion.VisualizarTransaccionLinkQR",
  };

  static Procesos = {
    LISTAR: "ECF.Proceso.Listar",
    EJECUTAR: "ECF.Proceso.Ejecutar",
  };

  static ReportesCompaniasVinculadas = {
    LISTAR_TRANSACCIONES: "ECF.Compania.Transacciones.Listar",
    LISTAR_TERMINALES: "ECF.Compania.Terminales.Listar",
    LISTAR_COMERCIOS: "ECF.Compania.Comercios.Listar"
  }

  static Graficos = {
    VER_GRAFICOS: "ECF.Graficos.Ver",
    CARD_VENTAS_MES: "ECF.Graficos.Card.VentasMes.Ver",
    CARD_TOTAL_VENTAS_MES: "ECF.Graficos.Card.TotalVentasMes.Ver",
    CARD_COMPRAS_MES: "ECF.Graficos.Card.ComprasMes.Ver",
    CARD_TOTAL_COMPRAS_MES: "ECF.Graficos.Card.TotalComprasMes.Ver",
    CARD_INFORMACION_CERTIFICADO:
      "ECF.Graficos.Card.InformacionCertificado.Ver",
    TABLA_VENTAS: "ECF.Graficos.TablaVentas.Ver",
    TABLA_COMPRAS: "ECF.Graficos.TablaCompras.Ver",
    GRAFICO_PIE_VENTAS: "ECF.Graficos.PieComprobantesVentas.Ver",
    GRAFICO_PIE_COMPRAS: "ECF.Graficos.PieComprobantesCompras.Ver",
    GRAFICO_VENTAS: "ECF.Graficos.ComprobantesVentas.Ver",
    GRAFICO_COMPRAS: "ECF.Graficos.ComprobantesCompras.Ver",
    GRAFICO_TRANSACCIONES_REALIZADAS:
      "ECF.Graficos.TransaccionesRealizadas.Ver",
    GRAFICO_TOP_10_CLIENTES: "ECF.Graficos.Top10Clientes.Ver",
    GRAFICO_BOTTOM_10_CLIENTES: "ECF.Graficos.Bottom10Clientes.Ver",
    GRAFICO_TOP_10_PROVEDORES: "ECF.Graficos.Top10Proveedores.Ver",
    GRAFICO_BOTTOM_10_PROVEDORES: "ECF.Graficos.Bottom10Proveedores.Ver",
  };

  static Items = {
    LISTAR: "ECF.Item.LISTAR",
    EDITAR: "ECF.Item.EDITAR",
    CREAR: "ECF.Item.CREAR",
    EXPORTAR: "ECF.Item.EXPORTAR",
  };

  static SolicitudTenant = {
    LISTAR: "ECF.SolicitudTenant.Listar",
    EVALUAR: "ECF.SolicitudTenant.EvaluarSolicitud",
    EDITAR: "ECF.SolicitudTenant.Editar"
  };

  static Categoria = {
    LISTAR: "ECF.Categoria.Listar",
    EDITAR: "ECF.Categoria.Editar",
    CREAR: "ECF.Categoria.Crear",
    EXPORTAR: "ECF.Categoria.Exportar",
  };

  static Vendedor = {
    LISTAR: "ECF.Vendedor.Listar",
    EDITAR: "ECF.Vendedor.Editar",
    CREAR: "ECF.Vendedor.Crear",
    EXPORTAR: "ECF.Vendedor.Exportar",
  };

  static TerminalPOS = {
    LISTAR: "ECF.TerminalPOS.Listar",
    EDITAR: "ECF.TerminalPOS.Editar",
    CREAR: "ECF.TerminalPOS.Crear",
    EXPORTAR: "ECF.TerminalPOS.Exportar",
  };

  static MetodoPago = {
    LISTAR: "ECF.MetodoPago.Listar",
    EDITAR: "ECF.MetodoPago.Editar",
    CREAR: "ECF.MetodoPago.Crear",
    EXPORTAR: "ECF.MetodoPago.Exportar",
  };

  static CargaMasiva = {
    CARGAR: "ECF.CargaMasiva.CARGAR",
  };

  static Cliente = {
     LISTAR: "ECF.Cliente.Listar",
     EDITAR: "ECF.Cliente.Editar",
     CREAR: "ECF.Cliente.Crear",
     EXPORTAR: "ECF.Cliente.Exportar",
  };
}
